import { render } from "./ListIzinTidakSetujuView.vue?vue&type=template&id=7c491092"
import script from "./ListIzinTidakSetujuView.vue?vue&type=script&lang=js"
export * from "./ListIzinTidakSetujuView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__